import React, { useEffect, useState } from "react";
import Routes from "./routes";
import { BrowserRouter } from "react-router-dom";
import { AppProvider } from "./contexts/Context";
import toast, { Toaster } from "react-hot-toast";
import { OverlayLoading } from "./components/OverlayLoading";
import { useAuth } from "./hooks/useAuth";
import axios from "axios";
import { fetchCurrentTerm } from "./redux/slices/term";
import { useDispatch } from "react-redux";
import { api } from "./api/axios";

function App() {
  React.useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);
  const { isInitialized } = useAuth();
  const { user } = useAuth();
  const dispatch = useDispatch();
  const [termName, setTermName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [results, setResults] = useState([]);
  //current term
  useEffect(() => {
    dispatch(fetchCurrentTerm())
      .unwrap()
      .then((res) => {
        setTermName(res);
      })
      .catch((error) => {});
  }, []); // Only fetch the current term from the API once on app load

  useEffect(() => {
    if (user && user?.role !== "admin" && termName) {
      getResults();
    }
  }, [user, termName]); // Re-run result fetching when the termName state is successfully set

  const getResults = async () => {
    try {
      setIsLoading(true);
      api
        .get(
          `/results/studentsresults/${termName?.session}/${termName?.term}/${user?.role === "teacher" ? user?.classHandled : user?.currentClass}`,
        )
        .then((res) => res.data)
        .then((data) => {
          if (data && data.results) {
            setResults(data.results);
          } else {
            setResults([]);
          }
        })
        .catch((error) => console.error(error))
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error("Error fetching results:", error);
      setIsLoading(false);
    }
  };
  return (
    <AppProvider>
      <div className="App">
        <BrowserRouter>
          {!isInitialized || isLoading ? <OverlayLoading /> : <Routes />}

          <Toaster
            position="top-right"
            reverseOrder={false}
            toastOptions={{
              // Define default options
              className: "",
              duration: 5000,
              style: {
                background: "#fff",
                color: "#000",
              },

              // Default options for specific types
              success: {
                duration: 5000,
                theme: {
                  primary: "blue",
                  secondary: "black",
                },
              },
            }}
          />
        </BrowserRouter>
      </div>
    </AppProvider>
  );
}

export default App;
